//=require main.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require alertifyjs/build/alertify.js

$.validator.setDefaults({
    errorElement: 'div',
    errorPlacement: function (error, element) {
        error.addClass('invalid-feedback');
        element.closest('.form-group').append(error);
    },
    success: function ( label, element ) {
        $(element).addClass('is-valid');
    },
    highlight: function (element) {
        $(element).removeClass('is-valid').addClass('is-invalid');
    },
    unhighlight: function (element) {
        $(element).removeClass('is-valid is-invalid');
    }
});

$(function () {
    $('.hide-password').click(function (){
        let $parent = $(this).parent().parent();
        let inputPass = $parent.find('input');
        let hidePass = $parent.find('img.hide-password');
        const type = inputPass.attr('type');
        if (type === 'password') {
            inputPass.attr('type', 'text');
            hidePass.attr('src', '/images/svgs/icon-show-pass.svg');
        } else if (type === 'text') {
            inputPass.attr('type', 'password');
            hidePass.attr('src', '/images/v2/visible-pass.png');
        }
    })

    $('.input-name .del-name, .input-email .del-name').click(function () {
        $(this).hide();
        $(this).closest('.position-relative').find('input').val('');
        $(this).closest('.position-relative').find('input').focus();
    });

    $('.input-password .del-pass').click(function () {
        let $parent = $(this).parent().parent();
        let inputPass = $parent.find('input');
        let $hidePass = $parent.find('.hide-password');
        inputPass.attr('type', 'password');
        $hidePass.attr('src', '/images/v2/visible-pass.png');
        $(this).hide();
        inputPass.val('');
        inputPass.focus();
        $hidePass.hide();
    });

    $('.sign-up-form #name, .login-form #email, .sign-up-form #email, .login-form #password, .sign-up-form #password').keyup(function () {
        let $iconDel = $(this).closest('.position-relative').find('.del-name');
        if ($(this).val()) {
            $iconDel.show();
        } else {
            $iconDel.hide();
        }
    });

    $('.login-form #password, .sign-up-form #password, .sign-up-form #password-new, .sign-up-form #password-new-confirm').keyup(function () {
        let parent = $(this).parent();
        if ($(this).val()) {
            parent.find('.hide-password').show();
            parent.find('.del-pass').show();
        } else {
            $(this).attr('type', 'password');
            parent.find('.hide-password').attr('src', '/images/v2/visible-pass.png');
            parent.find('.hide-password').hide();
            parent.find('.del-pass').hide();
        }

        if ($(this).valid() === true ) {
            parent.find('.img-icon').css('bottom', '28px');
            parent.find('.img-icon-login').css('bottom', '30px');
        } else {
            parent.find('.img-icon').css('bottom', '28px');
            parent.find('.img-icon-login').css('bottom', '30px');
        }
    });

    $('.login-form').validate({
        // focusInvalid: false,
        ignore: [],
        rules: {
            name: {
                required: true,
            },
            username: {
                required: true,
                email: true
            },
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
                minlength: 6
            },
        },
        messages: {
            name: {
                required: "Vui lòng nhập họ tên",
            },
            username: {
                required: "Vui lòng nhập email",
                email: "Định dạng email không chính xác"
            },
            email: {
                required: "Vui lòng nhập email",
                email: "Định dạng email không chính xác"
            },
            password: {
                required: "Vui lòng nhập mật khẩu",
                minlength: "Mật khẩu bao gồm tối thiểu 6 kí tự"
            },
        },
        submitHandler: function (form) {
            form.submit();
        }
    });

    // validation
    $('.sign-up-form').validate({
        // focusInvalid: false,
        ignore: [],
        rules: {
            name: {
                required: true,
            },
            username: {
                required: true,
                email: true
            },
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
                minlength: 8
            },
            passwordConfirmation: {
                required: true,
                minlength: 8
            },
            password_new: {
                required: true,
                minlength: 8
            },
            password_new_confirm: {
                required: true,
                minlength: 8,
            }
        },
        messages: {
            name: {
                required: "Vui lòng nhập họ tên",
            },
            username: {
                required: "Vui lòng nhập email",
                email: "Định dạng email không chính xác"
            },
            email: {
                required: "Vui lòng nhập email",
                email: "Định dạng email không chính xác"
            },
            password: {
                required: "Vui lòng nhập mật khẩu",
                minlength: "Mật khẩu bao gồm tối thiểu 8 kí tự"
            },
            passwordConfirmation: {
                required: "Vui lòng nhập mật khẩu mới",
                minlength: "Mật khẩu mới bao gồm tối thiểu 8 kí tự"
            },
            password_new: {
                required: "Vui lòng nhập mật khẩu mới",
                minlength: "Mật khẩu mới bao gồm tối thiểu 8 kí tự"
            },
            password_new_confirm: {
                required: "Vui lòng nhập xác nhận mật khẩu",
                minlength: "Mật khẩu xác nhận bao gồm tối thiểu 8 kí tự",
            },
        },
        submitHandler: function (form) {
            form.submit();
            // if ($('.btn-send-mail').length) {
            //     location.href = '/quen-mat-khau-code';
            // }
            // if ($('.btn-new-pass').length) {
            //     location.href = '/dang-nhap';
            // }
        }
    });

    $('.signup-designer').on('click', function () {
        console.log($(this))
        $('.sign-up-form').validate({
            // focusInvalid: false,
            ignore: [],
            rules: {
                name: {
                    required: true,
                },
                email: {
                    required: true,
                    email: true
                },
                password: {
                    required: true,
                    minlength: 8
                },
                password_new: {
                    required: true,
                    minlength: 8
                },
                password_new_confirm: {
                    required: true,
                    minlength: 8,
                }
            },
            messages: {
                name: {
                    required: "Vui lòng nhập họ tên",
                },
                email: {
                    required: "Vui lòng nhập email",
                    email: "Định dạng email không chính xác"
                },
                password: {
                    required: "Vui lòng nhập mật khẩu",
                    minlength: "Mật khẩu bao gồm tối thiểu 8 kí tự"
                },
                password_new: {
                    required: "Vui lòng nhập mật khẩu mới",
                    minlength: "Mật khẩu mới bao gồm tối thiểu 8 kí tự"
                },
                password_new_confirm: {
                    required: "Vui lòng nhập xác nhận mật khẩu",
                    minlength: "Mật khẩu xác nhận bao gồm tối thiểu 8 kí tự",
                },
            },
            submitHandler: function (form) {
                form.submit();
                // if ($('.btn-send-mail').length) {
                //     location.href = '/quen-mat-khau-code';
                // }
                // if ($('.btn-new-pass').length) {
                //     location.href = '/dang-nhap';
                // }
            }
        });
    });


    function checkPasswordMatch() {
        // $("#checkPasswordMatch").html('');
        if ($("#password-new").val().length >= 8 && $("#password-new-confirm").val().length >= 8) {
            let password = $("#password-new").val();
            let confirmPassword = $("#password-new-confirm").val();
            if ($("#password-new").valid() && $("#password-new-confirm").valid()) {
                if (password !== confirmPassword) {
                    $("#checkPasswordMatch").html("<img style='margin-top: -4px' src='/images/v2/cancle-pass.png'> Mật khẩu không khớp").css("color", "#D91636");
                    $('.btn-new-pass').prop('disabled', true);
                } else {
                    $("#checkPasswordMatch").html("<img style='margin-top: -4px' src='/images/v2/tick-pass.png'> Mật khẩu hợp lệ").css("color","#13BF41");
                    $('.btn-new-pass').prop('disabled', false);
                }
            }

        } else {
            $("#checkPasswordMatch").html('');
        }
    }

    $("#password-new").keyup(checkPasswordMatch);
    $("#password-new-confirm").keyup(checkPasswordMatch);

});
